import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { SignInService } from '../services';
import { USER_CLAIMS, USER_ROLES } from '../services/sign-in.service';

export const HasAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const signInService = inject(SignInService);
    const claims = route.data['claims'] as Array<USER_CLAIMS> || [];
    const roles = route.data['roles'] as Array<USER_ROLES> || [];
    return signInService.userHasAccess(claims, roles);
};
